// Deprecated. Please refrain from new usage
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import * as PropTypes from "prop-types";
import { useTheme } from "@material-ui/core";
import Typography from "../Helpers/Typography";
import { MoreHorizontal } from "../Icons/MoreHorizontal";
import { PermissionedDisplay } from "../Layout";
import { useTestIds } from "../../hooks/useTestIds";

const OverflowMenu = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const theme = useTheme();
  const testIds = useTestIds("vehicle-detail-overflow-menu");

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const selectOption = (func) => {
    if (func) func();
    handleClose();
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 10,
        right: 5,
      }}
    >
      <Button
        aria-owns={anchorEl ? "simple-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          padding: "16px, 16px",
        }}
        data-testid={testIds.ellipsisButton}
      >
        <MoreHorizontal fillColor={theme.palette.background.paper} />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid={testIds.wrapper}
      >
        {options.map((option, idx) => (
          <PermissionedDisplay permission={option?.permission} key={option.label}>
            <MenuItem
              onClick={() => selectOption(option.action)}
              data-testid={`${testIds.option}-${idx}`}
            >
              <Typography>{t(`Menus.${option.label}`)}</Typography>
            </MenuItem>
          </PermissionedDisplay>
        ))}
      </Menu>
    </div>
  );
};

OverflowMenu.propTypes = {
  options: PropTypes.array.isRequired,
};

export default OverflowMenu;
